import React, {useContext, useMemo} from 'react';
import {useSelector} from 'react-redux';

import {mapDateFormat} from 'src/utils/mapDateFormat';

import DiffTime from '@pb/kit-component-diff-time';
import {FormattedDate} from '@pb/kit-component-formatters';
import {LocaleContext} from '@pb/kit-context-locale';


import {UserActivitySource} from '../../constants';
import {
    userSearchResultLastActiveDataSelector,
    userSearchResultLastActiveResultSelector,
} from '../../slices/user-search-result-last-active.slice';

type Props = {
    userId: number,
    activitySource: UserActivitySource,
};

export const LastActivityCell = ({userId, activitySource}: Props) => {
    const {isLoading, loadingError} = useSelector(userSearchResultLastActiveDataSelector);
    const result = useSelector(userSearchResultLastActiveResultSelector);
    const {locale} = useContext(LocaleContext);

    const lastMobileActivity = useMemo(() => {
        const activityMap = result?.data[activitySource];

        return activityMap ? activityMap[userId] : null;
    }, [result, userId, activitySource]);

    if (isLoading || loadingError || !lastMobileActivity) {
        return null;
    }

    return (
        <span
            title={FormattedDate.format({
                value: lastMobileActivity,
                format: mapDateFormat(locale.dateFormat, 'NUMERIC'),
            }) || ''}>
            <DiffTime
                key={lastMobileActivity}
                createdDate={lastMobileActivity}
                fullUnits={true}
            />
        </span>
    );
};
